import _ from 'underscore';
import { ProjectionGridBaseColumn } from '@bingads-webui/projection-grid-base-column';
import { MAX_NUMBER_OF_RECOMMENDATION_SAMPLES } from '@bingads-webui-campaign/recommendation-core';

export class SearchExampleColumn extends ProjectionGridBaseColumn {
  constructor({ i18n, recommendationType }) {
    const title = i18n.getString('Details_View_SQ') || 'Search queries that could trigger your ad';

    super({
      name: 'SearchExample',
      property: 'Opportunities/SearchExamples',
      title,
      bodyClasses: ['grid-column-searchExample'],
      colClasses: ['col-longText'],
      sortable: false,
      helpId: 'pop_BA_Recommendations_DSA_SQ',
      type: 'string',
      helpAriaLabel: i18n.getString('Click to learn more about {{item}}', { item: title }),
    });
    this.i18n = i18n;
    this.recommendationType = recommendationType;
  }

  template({
    value: {
      SearchExamples,
    },
  }) {
    if (_.size(SearchExamples) > MAX_NUMBER_OF_RECOMMENDATION_SAMPLES) {
      return `${_.first(SearchExamples, MAX_NUMBER_OF_RECOMMENDATION_SAMPLES).join(', ')} ...`;
    }
    return SearchExamples.length > 0 ? SearchExamples.join(', ') : '-';
  }

  get property() {
    return {
      get: item => _.first(item.Opportunities),
    };
  }
}
